<template>
    <p>
        Hello!
    </p>
</template>
<script>
    export default {
        data: function () {
            return {}
        },
        methods: {}
    };
</script>
<style scoped>
</style>